import { createSelector } from '@reduxjs/toolkit';
import { FDealType, FOfferType } from '../../../../packages/JsonQuery';
import { keys } from 'ramda';
import { selectDealType, selectOfferType } from 'shared/selectors/jsonQuery';
import { capitalize } from 'shared/utils/string';

const OFFER_TYPE_NAMES: Partial<Record<FOfferType, string>> = {
  [FOfferType.Flat]: 'квартиру в новостройке и вторичке',
  [FOfferType.FlatNew]: 'квартиру в новостройке',
  [FOfferType.FlatOld]: 'квартиру во вторичке',
  [FOfferType.FlatShared]: 'долю',
  [FOfferType.Room]: 'комнату',
  [FOfferType.House]: 'дом, дачу',
  [FOfferType.HousePart]: 'часть дома',
  [FOfferType.Townhouse]: 'таунхаус',
  [FOfferType.Land]: 'участок',
  [FOfferType.Bed]: 'койко-место',
  [FOfferType.Garage]: 'гараж',
  [FOfferType.Office]: 'офис',
  [FOfferType.TradeArea]: 'торг. площадь',
  [FOfferType.Warehouse]: 'склад',
  [FOfferType.FreeAppointmentObject]: 'ПСН',
  [FOfferType.PublicCatering]: 'общепит',
  [FOfferType.Manufacture]: 'производ.',
  [FOfferType.AutoService]: 'автосервис',
  [FOfferType.Building]: 'здание',
  [FOfferType.DomesticServices]: 'быт. услуги',
  [FOfferType.CommercialLand]: 'комм. землю',
  [FOfferType.Coworking]: 'коворкинг',
};

export const selectOfferTypeLabel = createSelector([selectDealType, selectOfferType], (dealType, offerType) => {
  if (offerType === FOfferType.Hotel) {
    return 'Отели';
  }

  if (offerType === FOfferType.Residential) {
    return 'Жилую';
  }

  if ((dealType & FDealType.Rent) !== 0 && (offerType & FOfferType.Flat) !== 0) {
    return 'Квартиру';
  }

  if (offerType in OFFER_TYPE_NAMES) {
    return capitalize(OFFER_TYPE_NAMES[offerType] as string);
  }

  const offerTypeName = keys(OFFER_TYPE_NAMES)
    .map(type => ((type & offerType) !== 0 ? OFFER_TYPE_NAMES[type] : null))
    .filter(Boolean)
    .join(', ');

  return (offerTypeName && capitalize(offerTypeName)) || '';
});
